import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const pedagogicalContentsFields: FieldInterface[] = [
  {
    key: 'code',
    originKey: 'code',
    type: FIELD_TYPES.string,
  },
  {
    key: 'content',
    originKey: 'content',
    type: FIELD_TYPES.string,
  },
  {
    key: 'externalId',
    originKey: 'external_id',
    type: FIELD_TYPES.string,
  },
  {
    key: 'kind',
    originKey: 'kind',
    type: FIELD_TYPES.string,
  },
  {
    key: 'label',
    originKey: 'label',
    type: FIELD_TYPES.string,
  },
  {
    key: 'link',
    originKey: 'link',
    type: FIELD_TYPES.string,
  },
]

const pedagogicalContentsRelations: RelationInterface[] = []

export { pedagogicalContentsFields, pedagogicalContentsRelations }
